module.exports = __webpack_public_path__ + "static/media/siddharth-ooty-trip-06.94d21a91.png";